import React from "react"
import SEO from "../components/seo"
import Layout from '../containers/layout/layout'
import Header from '../containers/layout/header'
import Footer from '../containers/layout/footer'
import PageHeader from '../containers/about-us/page-header'
import ResourcesArea from '../containers/about-us/resources-area'
// import ISO27001Area from '../containers/about-us/iso'
import FeaturesArea from '../containers/index-page/features-area'
import TestimonialArea from '../containers/global/testimonial-area/section-one'
import ClientsArea from '../containers/global/clients-area'
import ContactArea from '../containers/global/contact-area'
import GradationArea from '../containers/index-page/gradation-area'

const AboutPage = ({ location }) => (
  <Layout location={location}>
    <SEO title="About Us" />
    <Header />
    <main className="site-wrapper-reveal">
      <PageHeader />
      <FeaturesArea />
      {/* <ISO27001Area /> */}
      <GradationArea />
      <ResourcesArea />
      <TestimonialArea />
      <ClientsArea />
      <ContactArea />
    </main>
    <Footer />
  </Layout>
)

export default AboutPage
